import { useIntl } from "react-intl";

const UserLimitPerSite = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.userLimitPerSite.title",
            defaultMessage: "User limit per site"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPage.modalContents.userLimitPerSite.body",
            defaultMessage:
                "This is the maximum number of users or user licenses you can add to each of your Confluence sites."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default UserLimitPerSite;
